import styled from '@emotion/styled';
import MUIRadio from '@mui/material/Radio';
import React from 'react';

import { hexToRgba } from '~/common/util/format';

const BpIcon = styled.span<any>`
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors?.white};
  border: 2px solid
    ${(props) =>
      props.error
        ? props.theme.colors?.red[600]
        : props.theme.colors?.gray[700]};
  transition: box-shadow 0.25s ease-in-out;

  & .MuiRadio-root {
    font-size: 1rem;
  }

  .Mui-focusVisible & {
    box-shadow: ${(props) => {
      return props.disableRipple
        ? `0 0 0 3px ${hexToRgba(props.theme.colors?.blue[400], 0.6)}`
        : 'none';
    }};
  }

  input:hover ~ & {
    background-color: ${(props) => props.theme.colors?.gray[100]};
  }

  input:disabled ~ &,
  input:disabled:hover ~ & {
    box-shadow: none;
    background-color: transparent;
    border-color: ${(props) => hexToRgba(props.theme.colors?.gray[700], 0.3)};
  }
`;

const BpCheckedIcon = styled<any>(BpIcon)`
  background-color: ${(props) => props.theme.colors?.blue[500]};
  border-color: ${(props) => props.theme.colors?.blue[500]};

  &::before {
    display: inline-block;
    content: '';
    position: relative;
    width: 50%;
    height: 50%;
    border-radius: 50%;
    background: ${(props) => props.theme.colors?.white};
  }

  input:disabled ~ &,
  input:disabled:hover ~ & {
    background-color: ${(props) => props.theme.colors?.blue[600]};
    opacity: 0.3;
  }

  input:hover ~ &,
  input:focus ~ & {
    background-color: ${(props) => props.theme.colors?.blue[600]};
    border-color: ${(props) => props.theme.colors?.blue[600]};
    box-shadow: ${(props) => {
      return props.disableRipple
        ? `0 0 0 3px ${hexToRgba(props.theme.colors?.blue[400], 0.6)}`
        : 'none';
    }};
  }
`;

type RadioProps = React.ComponentProps<typeof MUIRadio> & {
  error?: boolean;
};

const Radio = React.forwardRef<any, RadioProps>(({ ...props }, ref) => {
  return (
    <MUIRadio
      ref={ref}
      disableRipple
      checkedIcon={<BpCheckedIcon disableRipple />}
      icon={<BpIcon disableRipple error={props.error} />}
      {...props}
    />
  );
});

Radio.displayName = 'Radio';

export default Radio;
